import { useEffect } from "react";
import { useObservable } from "micro-observables";

import {
    newDataSelector,
    selectedElement, setActiveDataSelector,
    setNewDataSelector,
    setSelectedElement
} from "../services/stepThree";
import findLinkInIframe from "../utils/findLinkInIframe";
import getElementPath from "../../utils/getElementPath";
import collapseXpath from "../../utils/collapseXpath";
import { DEFAULT_SELECTOR } from "../constants";

const useStepThree = () => {
    const newData = useObservable(newDataSelector);
    const element = useObservable(selectedElement);

    useEffect(
        () => {
            setActiveDataSelector(newData);
        },
        [ newData ]
    );

    useEffect(
        () => {
            if(!element || !element.target) {
                return;
            }

            const link = findLinkInIframe(element.target);
            if(!link) {
                return;
            }
            const xpath = getElementPath(link);

            const newDataSelector = newData ? { ...newData } : { ...DEFAULT_SELECTOR };

            let selectors = [ ...newDataSelector.selectors, { selector: `${xpath}/@href`, sub_selector: "" } ];

            if(selectors.length > 1) {
                selectors = collapseXpath(selectors);

                newDataSelector.is_multiple = true;
                newDataSelector.action_code =  "CREATE_NEW_SCRAPE_TASK";
            }

            newDataSelector.selectors = selectors;

            setNewDataSelector(newDataSelector);
            setSelectedElement(null);
        },
        [ newData, element ]
    );
};

export default useStepThree;
